import React from 'react';

/** 系统公告：琥珀金（与前线消息区分） */
const THEME = {
  background: '#fff8e1',
  border: '1px solid #f0c36d',
  accent: '#b8860b',
  icon: '#d4a017',
  closeHover: '#ffe08a',
  label: '系统公告'
};

/**
 * 指挥页系统公告卡片（精小）
 */
export default function DashboardAnnouncementBanner({
  visible,
  announcement,
  onClose
}) {
  if (!visible || !announcement) return null;

  return (
    <div
      style={{
        background: THEME.background,
        border: THEME.border,
        borderLeft: '3px solid #d4a017',
        borderRadius: 6,
        padding: '5px 8px',
        minWidth: 220,
        maxWidth: 'min(320px, 100%)',
        boxShadow: '0 2px 8px rgba(180, 130, 20, 0.16)',
        animation: 'zhxtMapTopSlideDown 0.28s ease-out',
        pointerEvents: 'auto'
      }}
      role="status"
      aria-live="polite"
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 6 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <span style={{ marginRight: 4, fontSize: 11, color: THEME.icon, lineHeight: 1 }} aria-hidden>📢</span>
            <span style={{ fontSize: 11, fontWeight: 600, color: THEME.accent }}>
              {THEME.label}
              {announcement.title ? ` · ${announcement.title}` : ''}
            </span>
          </div>
          <div style={{
            fontSize: 12,
            fontWeight: 600,
            color: '#4a3b0a',
            lineHeight: 1.35,
            wordBreak: 'break-word'
          }}
          >
            {announcement.content}
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: THEME.accent,
            fontSize: 13,
            cursor: 'pointer',
            padding: '0 2px',
            borderRadius: 3,
            lineHeight: 1,
            flexShrink: 0
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = THEME.closeHover; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
          title="关闭公告"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
